import { useEffect } from 'react'

import s from './styles.module.scss'

export default function ChatbotWidget() {
  useEffect(() => {
    if (!window.ktt10) return

    if (window.__chatbot_initialized) return
    window.__chatbot_initialized = true

    window.ktt10.setup({
      id: 'YckKOTPEFyy6',
      accountId: '1415559',
      color: '#4C5EFE',
      type: 'floating',
    })

    const popup = document.getElementById('custom-popup')
    const popupText = document.getElementById('custom-popup-text')
    const closeBtn = document.getElementById('custom-popup-close')

    if (!popup || !popupText || !closeBtn) return

    popup.style.display = 'flex'

    const openChat = () => {
      const chatBtn = document.querySelector('.ktt10-btn')
      if (chatBtn) chatBtn.click()
      popup.style.display = 'none'
    }

    popupText.addEventListener('click', openChat)
    closeBtn.addEventListener('click', () => (popup.style.display = 'none'))

    return () => {
      popupText.removeEventListener('click', openChat)
    }
  }, [])

  return (
    <div id="custom-popup" className={s.popup}>
      <button id="custom-popup-close" className={s.popupClose}>
        &times;
      </button>
    </div>
  )
}
